import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card } from '@node-space/ui-components'

export interface RewardsMaximizeCardProps {
  maxMonthlyRewards: string
  currency: string
}

export const RewardsMaximizeCard = ({ maxMonthlyRewards, currency }: RewardsMaximizeCardProps) => {
  const { t } = useTranslation()

  return (
    <Box className="relative overflow-hidden">
      <Card variant="static" emphasis full>
        <Box flex align="start" justify="between">
          <Box flexCol gapY={8} paddingY={8} className="flex-1">
            <h2 className="text-h2 text-foreground-prominent">{t('rewards.maximiseRewards')}</h2>
            <p className="text-body-strong-large text-foreground-subdued">
              {t('rewards.maximiseRewardsDescription', {
                amount: maxMonthlyRewards,
                currency,
              })}
            </p>
          </Box>

          <Box className="relative w-[200px] h-[200px] shrink-0 z-10">
            <img
              src={`${process.env.ASSETS_URL}/rewards/digitalWallets.png`}
              alt="Digital Wallets"
              className="w-full h-full object-contain"
            />
          </Box>
        </Box>
      </Card>
      <Box className="absolute top-0 right-[20px] scale-150">
        <img src={`${process.env.ASSETS_URL}/rewards/curveLine.svg`} alt="Vector" />
      </Box>
    </Box>
  )
}
